require ('./jquery.autocomplete.js');

(function(wnd){
  function SearchForm(container, params) {
    try {
      if (!container || (container && container.length == 0)) {
        throw 'Container is required!';
      }

      this.container = container;
      if (params) {
        this.setParams(params);
      }
      this.init();
    } catch (error) {
      console.error(error);
    }
  }

  SearchForm.prototype = {
    container: undefined,
    form: undefined,
    input: undefined,
    resultLimit: 6,
    resultSet: [{
      "name":"Állatos lufik",
      "link":"/termek_lista.html",
    },{
      "name":"Verdás (Cars) lufi",
      "link":"/termek_lista.html",
    }],
    init: function() {
      this.setElements();
      this.addDOMEvents();
      this.initAutocomplete();
    },
    setElements: function() {
      this.form = this.container.find('form');
      this.input = this.form.find('[data-purpose="search-field"]');
    },
    addDOMEvents: function() {
      var _self = this;
      this.input.keydown(function(e){
        if (e.keyCode == 13) {
          e.preventDefault();
          var value = $(this).val();

          if (value.trim() != '') {
            _self.form.submit();
          }
        }
      });

    },
    setParams: function(params) {
      if (params.resultSet) this.setResultSet(params.resultSet);
    },
    initAutocomplete: function() {
      if (this.input && this.input.length > 0) {
        var _self = this;

        this.input.autoComplete({
          minLength: 2,
          appendTo: _self.container,
          source: function(request, response) {
			$.getJSON('ajax/get-category-list.php', { q: request }, function(data){ response(data); 
    // }
				var result = [];

				var terms = request.replace(/\[|\]|\\|\/|\(|\)|\.|\+|\*|\?/gi, '').split(' ');
				var term = terms.filter(function(term){ return term.length > 0 }).join('|');
				var reg = new RegExp('('+term+')', 'gi');



				for (var i = 0; i < data.length; i++) {
				  var item = Object.assign({}, data[i]);
				  var matches = item.name.match(reg);
				  if (matches && matches.length > 0) {
					item.count = matches.length;
					item.label = item.name.replace(reg, '<span class="searched">$1</span>');

					result.push(item);
				  }
				}

				result.sort(_self.sortResultSet);


				if (result.length > _self.resultLimit) {
				  result = result.slice(0, _self.resultLimit);
				}

				var extra = {
				  label: '<span class="all-result">további találatok a "'+term+'" kifejezésre ></span>',
				  value: term,
				};

				result.push(extra);

				response(result);
			});
          },
          renderItem: function(item, search) {
            var inner = '';
            var value = typeof item.link !== 'undefined' ? item.name : item.value;
            if (typeof item.link !== 'undefined') {
              inner = '<a href="'+item.link+'">'+item.label+'</a>';
            } else {
              inner = item.label;

            }
            return '<div class="autocomplete-suggestion '+(typeof item.link !== 'undefined' ? '' : 'submit-row')+'" data-value="'+value+'" data-link="'+(typeof item.link !== 'undefined' ? item.link : '')+'">'+inner+'</div>';
          },
          onSelect: function(e, term, item) {
            var link = $(item).data('link');
            if (link.trim() !== '') {
              document.location = link;
            } else {
              _self.input.val($(item).data('value'));
              _self.form.submit();
            }
          }
        });
      }
    },
    sortResultSet: function( a, b){
        if (a.count == b.count) {
            return 0;
        } else{
            return a.count > b.count ? -1 : 1;
        }
    },
    setResultSet: function(resultSet) {
      this.resultSet = resultSet;
    }
  };


  wnd.SearchForm = SearchForm;
})(window);
